'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ProductCatalogShowCtrl
 * @description
 * # ProductCatalogShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ProductCatalogShowCtrl', [
    '$scope', '$state', '$stateParams', 'ProductCatalog', function ($scope, $state, $stateParams, ProductCatalog) {
      $scope.productCatalog = {};
      ProductCatalog.find($stateParams.productId).then(function(response) {
        $scope.productCatalog = response.data.product_catalog;
      }, function(error) {
        ProductCatalog.error(error);
      });
  }]);
